import { Addresses } from '@agentsoftware/kraken-ts-sdk/sdk/models/shared';

export default (address: Addresses) => {
  const street = address.royalMailFormat.thoroughfare ? `${address.royalMailFormat.thoroughfare}, ` : '';
  const locality = address.royalMailFormat.dependentLocality ? `${address.royalMailFormat.dependentLocality}, ` : '';
  const outcode = address.royalMailFormat.postcode.split(' ')[0];
  return `${street}${locality}${outcode}`;
};
